import './SupportBox.scss';

const SupportBox = (() => {})();

export default SupportBox;
